import { render, staticRenderFns } from "./SettledCredits.vue?vue&type=template&id=d283da1a&"
import script from "./SettledCredits.vue?vue&type=script&lang=js&"
export * from "./SettledCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports